export const rawModes = {
    Incremental: {
        name: 'Incremental',
        abbreviation: 'Inc',
        help: 'Retrieves all data changes made after a particular date (watermark)',
        isBatched: true,
        refKeyRequired: true
    },
    SyncDeletes: {
        name: 'Sync_Deletes',
        abbreviation: 'Sync',
        help: 'Uses the provided ref key to compare source and destination tables. Removes rows from the destination table in Ignite if the rows do not exist in the source table.',
        isBatched: false,
        refKeyRequired: true
    },
    Full: {
        name: 'Full',
        abbreviation: 'Full',
        help: 'Loads the entire table in one pull',
        isBatched: false,
        refKeyRequired: true
    },
    Append: {
        name: 'Append',
        abbreviation: 'APND',
        help: 'All source data will be appended to the destination table. No ref key is required and no rows will be merged',
        isBatched: false,
        refKeyRequired: false
    },
    Incremental_CSA: {
        name: 'Incremental_CSA',
        abbreviation: 'CSA',
        help: 'Retrieves all data changes made after a particular date (watermark) for Epic systems',
        isBatched: true,
        refKeyRequired: true
    },
    Incremental_CDC: {
        name: 'Incremental_CDC',
        abbreviation: 'CDC',
        help: 'Retrieves all data changes made after a particular date (watermark)',
        isBatched: true,
        refKeyRequired: true
    },
    Backfill: {
        name: 'Backfill',
        abbreviation: 'Back',
        help: 'Loads historical data in reverse, like incremental, but backwards',
        isBatched: true,
        refKeyRequired: true
    },
    EntityMigration: {
        name: 'Entity_Migration',
        abbreviation: 'ENTM',
        help: 'Migrate entities from Legacy tables to Medallion tables',
        isBatched: false,
        refKeyRequired: false
    },
    Replace: {
        name: 'Replace',
        abbreviation: 'RPLC',
        help: 'All source data will replace all data existing in the destination table.',
        isBatched: false,
        refKeyRequired: false
    },
    SchemaMigration: {
        name: 'Schema_Migration',
        abbreviation: 'SCHM',
        help: 'Updates view of ingested data to reflect source schema changes',
        isBatched: false,
        refKeyRequired: false
    }
};

export const engineTypes = {
    IoEngine: 'io_engine',
    Legacy: 'legacy'
};

export const scheduleTypes = {
    New: 'New',
    Existing: 'Existing'
};

export const refModes = {
    Type1: 'Type 1',
    Type2: 'Type 2'
};

export const fileTypes = {
    Delimited: {
        name: 'Delimited',
        value: 'delimited',
        tooltip:
            'A delimited file is one where the columns are separated by some type of character, usually a comma, a pipe, or a tab.'
    },
    FixedWidth: {
        name: 'Fixed Width',
        value: 'fixed_width',
        tooltip:
            'A fixed-width file is one without delimiters, where instead each column has a defined width, and all characters from the beginning to end of that width are included in the column values'
    },
    Parquet: {
        name: 'Parquet',
        value: 'parquet',
        tooltip:
            'A parquet file is a column-oriented data file format designed for efficient data storage and retrieval. No additional configuration is needed.'
    },
    ZipArchive: {
        name: 'ZIP Archive',
        value: 'zip',
        tooltip:
            'A zip archive file is a compressed file format that bundles one or more files or directories into a single file.'
    }
};

export const globalAdminTenantIdUppercase = 'GDPDEV';

export const minDate = '2000-01-01';

export const maxDate = '9999-12-31';

export const defaultIncrementalTypeBatchSize = '20,000,000';

export const dbxUrlHostIdentifier = 'azuredatabricks';

export const dbxSessionStorageKey = 'dbx_auth_instances';

export const promoterType = {
    PromoterV2: {
        name: 'Promoter v2',
        value: 'Promoter_V2',
        description: 'Use source_data_ingest and source_data catalogs as the destination for ingested data',
        isFileSourceTypeOnly: false
    },
    LegacyWithHistory: {
        name: 'Legacy with history',
        value: 'Type 2',
        description: 'Legacy promoter mode (Type 2) - includes history table for this entity',
        isFileSourceTypeOnly: false
    },
    LegacyWithoutHistory: {
        name: 'Legacy without history',
        value: 'Type 1',
        description: 'Legacy promoter mode (Type 1) - no history tables created',
        isFileSourceTypeOnly: false
    },
    FileCopy: {
        name: 'File Copy',
        value: 'File_Copy',
        description:
            'Store a copy of the ingested file in a databricks volume - no manipulation of ingested data will take place',
        isFileSourceTypeOnly: false
    },
    Archive: {
        name: 'Archive',
        value: 'Archive',
        description:
            'Take an archive file and extract the contents into an Azure Blob Store for later ingestion (additional jobs will be required for the extracted files to be ingested).',
        isFileSourceTypeOnly: true
    }
};

export const watermarkKeyDatatype = {
    Integer: {
        name: 'Integer',
        value: 'int'
    },
    Float: {
        name: 'Float',
        value: 'float'
    },
    DateTime: {
        name: 'Date/Time',
        value: 'datetime'
    }
};
